<template>
  <div class="light-map-index position-relative flex-grow-1 d-flex flex-column">
    <div class="maptop d-flex justify-content-between" style="display:none">
      <div class="topsmallbox section-container" :class="{ dark: skinType }">
        <div class="boxzuo">
          <div class="words-container">
            <span class="lanzi">78</span>
            <span class="huizi" :class="{ light: skinType }">个</span>
          </div>
          <span class="heizi">智慧配电台区</span>
        </div>
        <div class="img-icon-container"
        :style="{ backgroundColor: skinType?'#ffffff19':'#C6E2FF' }">
          <span class="iconfont iconxiangmu2 img-icon img-icon-project"></span>
        </div>
      </div>
      <div class="topsmallbox section-container" :class="{ dark: skinType }">
        <div class="boxzuo">
          <div>
            <span class="lanzi">112</span>
            <span class="huizi" :class="{ light: skinType }">个</span>
          </div>
          <span class="heizi">物联网配电室</span>
        </div>
        <div class="img-icon-container"
        :style="{ backgroundColor: skinType?'#ffffff19':'#F5DECB' }">
          <span class="iconfont iconpeidianshi img-icon img-icon-room"></span>
        </div>
      </div>
      <div class="topsmallbox section-container" :class="{ dark: skinType }">
        <div class="boxzuo">
          <div>
            <span class="lanzi">5600</span>
            <span class="huizi" :class="{ light: skinType }">+</span>
          </div>
          <span class="heizi">服务居民用户</span>
        </div>
        <div class="img-icon-container"
        :style="{ backgroundColor: skinType?'#ffffff19':'#E1D7FA' }">
          <span class="iconfont iconbianyaqi img-icon img-icon-trans"></span>
        </div>
      </div>
      <div class="topsmallbox section-container" :class="{ dark: skinType }">
        <div class="boxzuo">
          <div>
            <span class="lanzi">390</span>
            <span class="huizi" :class="{ light: skinType }">+</span>
          </div>
          <span class="heizi">服务企业用户</span>
        </div>
        <div class="img-icon-container"
        :style="{ backgroundColor: skinType?'#ffffff19':'#C1D4F6' }">
          <span
            class="iconfont iconzhuangjirongliang img-icon img-icon-capacity"
          ></span>
        </div>
      </div>
      <div class="topsmallbox section-container" :class="{ dark: skinType }">
        <div class="boxzuo">
          <div>
            <span class="lanzi">10</span>
            <span class="huizi" :class="{ light: skinType }">省市</span>
          </div>
          <span class="heizi">业务推广应用</span>
        </div>
        <div class="img-icon-container"
        :style="{ backgroundColor: skinType?'#ffffff19':'#E1F3D8' }">
          <span class="iconfont iconyonghushuju img-icon img-icon-users"></span>
        </div>
      </div>
    </div>
    <project-list v-show="isShow"
      class="position-absolute projectList-container"
      :list="statisticsInfo.Project"
    ></project-list>
    <light-map
      :projectList="statisticsInfo.Project"
      class="flex-grow-1 light-map-container"
    >
    </light-map>
  </div>
</template>
<script>
import LightMap from '@/components/index/light-map.vue';
import ProjectList from '@/components/index/project-list.vue';
import { getInformation } from '../../api/home/home';
import { _BASE_Configuration } from '@/const/values.js';
export default {
  name: 'light-map-index',
  data() {
    return {
      statisticsInfo: {},
      isShow:_BASE_Configuration
    };
  },
  components: {
    LightMap,
    ProjectList,
  },
  created() {
    this.requestProjectsInfo();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    requestProjectsInfo() {
      return getInformation().then((res) => {
        this.statisticsInfo = res;
      });
    },
  },
};
</script>
<style scoped>
/* .liebiao {
  width: 30%;
  height: 40%;
} */
.imgtu {
  margin-top: 0.9rem;
}
.heizi {
  font-size: 1.2rem;
}
.lanzi {
  color: #409eff;
  font-size: 1.4rem;
}
.huizi {
  font-size: 1rem;
  margin-left: 0.7rem;
  color: #333333;
}
.huizi.light {
  color: #cccccc;
}
.boxzuo {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.img-icon-container {
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.1);
}
.dark .img-icon-container {
  background-color: rgba(255, 255, 255, 0.1);
}
.maptop {
  height: 12%;
  width: 100%;
}
.topsmallbox {
  width: 15%;
  height: 85%;
  padding: 2px 16px;
  display: flex;
  align-items: center;
  justify-self: center;
  border-radius: 0.3rem;
}
.topsmallbox + .topsmallbox {
  margin-left: 1rem;
}

/* 相对定位 */
.position-relative {
  position: relative;
}
/* 绝对定位 */
.position-absolute {
  position: absolute;
}
/* 地图 */
.general-info-container {
  right: 0;
  bottom: 0;
}
.projectList-container {
  right: 0;
  bottom: 0;
  width:500px;
  height: 18rem;
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.52);
  z-index:9999;
}
.imgtu {
  width: 2rem;
  height: 2rem;
}
.img-icon-trans {
  color: #9D77FB;
}
.img-icon-room {
  color: #F6A664;
}
.img-icon-project {
  color: #1D86F4;
}
.img-icon-capacity {
  color: #2D6AE3;
}
.img-icon-users {
  color: #67C23A;
}
</style>
